const frequencies = [
  {
    id: 0,
    name: 'Contado'
  },

  {
    id: 1,
    name: 'Día(s)'
  },

  {
    id: 2,
    name: 'Semana(s)'
  },

  {
    id: 3,
    name: 'Mes(es)'
  },

  {
    id: 4,
    name: 'Año(s)'
  }
]

export default frequencies
